import { iloomReviewsAuthApiClientToken } from "@apps/iloom_customization/tokens";
import ReviewsListResponseEntity from "@apps/reviews/entities/ReviewsLIstResponseEntity";
import VoteEntity from "@apps/reviews/entities/VoteEntity";
import ReviewsListResponseSchema from "@apps/reviews/schemas/ReviewsListResponseSchema";
import VoteSchema from "@apps/reviews/schemas/VoteSchema";
import { GetReviewsRequestParamsDTO } from "@apps/reviews/services/ReviewsServiceBase";
import { JsonMimeType } from "@lib/ApiClient";
import AuthApiClient from "@lib/ApiClient/AuthApiClient";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Infer, create } from "superstruct";
import { inject, injectable } from "tsyringe";

import { IloomAttributesFiltersSchema } from "../schemas/IloomAttributesFiltersSchema";

@injectable()
export class ReviewsApiService {
    public constructor(
        @inject(iloomReviewsAuthApiClientToken)
        private readonly apiClient: AuthApiClient
    ) {}

    getReviews(
        queryParams?: GetReviewsRequestParamsDTO
    ): Observable<ReviewsListResponseEntity> {
        return this.apiClient
            .get({
                url: "/review/getReviewList",
                responseType: "json",
                queryParams,
            })
            .pipe(
                map((response) => {
                    return create(response.body, ReviewsListResponseSchema);
                })
            );
    }

    getIllomAttributeFilters(): Observable<
        Infer<typeof IloomAttributesFiltersSchema>
    > {
        return this.apiClient
            .get({
                url: "/review/getAttributeFilters",
                responseType: "json",
            })
            .pipe(
                map((response) => {
                    return create(response.body, IloomAttributesFiltersSchema);
                })
            );
    }

    toggleVote(reviewId: number): Observable<VoteEntity> {
        return this.apiClient
            .post({
                url: "/review/toggleVote",
                body: JSON.stringify({ reviewId }),
                responseType: "json",
                contentType: JsonMimeType,
            })
            .pipe(map((res) => create(res.body, VoteSchema)));
    }
}
